import React from 'react';
import { useTranslation } from 'react-i18next';
import { RELEASE_NAME } from '../../core/config';
import { Button } from '../../visual-components/button/button';
import { GridContainer, GridItem } from '../../visual-components/grid/grid';
import { Spacer } from '../../visual-components/spacer/spacer';
import { Typography } from '../../visual-components/typography/typography';

type Props = {
  error: Error | null;
  debugInfo?: string;
};

export const FallbackUI: React.FC<Props> = ({ error, debugInfo }) => {
  const { t } = useTranslation();

  const onGoHome = () => {
    window.location.href = window.location.origin;
  };

  const errorMsg = error?.message;

  return (
    <GridContainer>
      <GridItem span="12">
        <Spacer size="08" />
        <Typography color="red" variant="headline-1">
          {t('errorPage.defaultPageTitle')}
        </Typography>
        <Spacer size="08" />
        <Typography color="black" variant="maintext">
          {t('errorPage.tryLaterOrContactSupport')}
        </Typography>
        {errorMsg ? (
          <>
            <Spacer size="02" />
            <Typography color="anthrazit" variant="maintext">
              {errorMsg}
            </Typography>
          </>
        ) : null}
        <Spacer size="04" />
        <Typography color="black" variant="smalltext">
          {t('global.debugInformation')}
        </Typography>
        <Spacer size="02" />
        <Typography color="anthrazit" variant="smalltext">
          {`${t('global.appVersion')}: ${RELEASE_NAME}`}
        </Typography>
        <Spacer size="02" />
        <Typography color="anthrazit" variant="smalltext">
          {`URL: ${window.location.href}`}
        </Typography>
        <Spacer size="02" />
        <Typography color="anthrazit" variant="smalltext">
          {`Timestamp UTC: ${new Date().toUTCString()}`}
        </Typography>
        {debugInfo ? (
          <>
            <Spacer size="02" />
            <Typography color="anthrazit" variant="smalltext">
              {debugInfo}
            </Typography>
          </>
        ) : null}
        <Spacer size="08" />
        <Button onClick={onGoHome}>{t('global.backToHome')}</Button>
      </GridItem>
    </GridContainer>
  );
};
